export const isValidNumber = (item) => {
    if (typeof item === "number") {
        if (item > 0) {
            return true;
        }
    }
    return false;
};
